import { useState, useEffect, useCallback, memo } from 'react';
import { styled } from 'twin.macro';
import dayjs from 'dayjs';

const ClockContainer = styled.div`
    font-size: 1.6rem;
    font-weight: 600;
    color: #2f2f2f;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    line-height: 1.4;
`;

const Time = styled.div`
    font-size: 2.4rem;
    font-weight: 700;
`;

const DateInfo = styled.div`
    font-size: 1.4rem;
    margin-top: 4px;
    color: #6c6c6c;
`;

const DigitalClock = () => {
    const getNow = useCallback(
        () => ({
            time: dayjs().format('hh:mm:ss A'),
            date: dayjs().format('dddd, MMMM D, YYYY'),
        }),
        []
    );

    const [now, setNow] = useState(getNow);

    useEffect(() => {
        const timerId = setInterval(() => {
            setNow(getNow());
        }, 1000);

        return () => clearInterval(timerId);
    }, [getNow]);

    return (
        <ClockContainer>
            <Time>{now.time}</Time>
            <DateInfo>{now.date}</DateInfo>
        </ClockContainer>
    );
};

export default memo(DigitalClock);
